import { createTheme as a } from "./ghl-ui.es855.js";
import l from "./ghl-ui.es1157.js";
import e from "./ghl-ui.es1164.js";
import i from "./ghl-ui.es984.js";
import c from "./ghl-ui.es923.js";
const d = (o) => {
  const {
    modalColor: r,
    textColor2: t,
    boxShadow3: m
  } = o;
  return {
    color: r,
    textColor: t,
    boxShadow: m
  };
}, h = a({
  name: "Modal",
  common: l,
  peers: {
    Scrollbar: e,
    Dialog: i,
    Card: c
  },
  self: d
}), L = h;
export {
  L as default,
  d as self
};
